export enum RequisitionScope {
    VESSEL = 'VESSEL',
    COMPANY = 'COMPANY',
}
